export default __webpack_public_path__ + "static/media/pinterest.531abf09.png";